import angular from 'angular';

/**
 * Allows for dynamically assigning filters in templates.
 * E.g.: in controller: $scope.nameFilter = 'uppercase'
 *       in template:   {{item | dynamicFilter:nameFilter}}
 *
 * Filter arguments (in addition to input) can be passed using
 * ":" as a separator.
 * E.g.: in controller: $scope.nameFilter = 'limitTo:0:20'
 *       in template:   {{item | dynamicFilter:nameFilter}}
 */
export function DynamicFilter($filter) {
  'ngInject';

  return function(input, filter) {
    if (angular.isString(filter)) {
      let split = filter.split(':');
      let args = [input].concat(split.slice(1));
      filter = split[0];
      return $filter(filter).apply(null, args);
    } else if (angular.isFunction(filter)) {
      return filter(input);
    } else {
      throw new Error(
        `dynamicFilter: filter must be either an Array or String. Got ${typeof filter}.`
      );
    }
  };
}
